import { useSyncExternalStore } from 'react';

const DEFAULT_STATE = { type: null, props: {} };

const notificationBannerHelper = () => {
  let state = DEFAULT_STATE;
  const listeners = new Set();
  let timer;

  const subscribe = listener => {
    listeners.add(listener);
    return () => listeners.delete(listener);
  };

  const getSnapshot = () => state;

  const notify = () => {
    listeners.forEach(l => l());
  };

  const hideMsg = () => {
    clearTimeout(timer);
    timer = undefined;
    state = DEFAULT_STATE;
    notify();
  };

  const showMsg = (type, props, timeout = 5000) => {
    state = { type, props };
    notify();
    clearTimeout(timer);
    timer = window.setTimeout(hideMsg, timeout);
  };

  const removeTimeout = () => {
    clearTimeout(timer);
  };

  const hideMsgWithTimeout = () => {
    clearTimeout(timer);
    timer = window.setTimeout(hideMsg, 5000);
  };

  return {
    showMsg,
    hideMsg,
    subscribe,
    getSnapshot,
    removeTimeout,
    hideMsgWithTimeout,
  };
};

// Hook for NotificationBanner to subscribe to the notification state.
// Uses useSyncExternalStore which is React-Compiler-safe and
// concurrent-mode-safe — no forceUpdate or setUpdater bridging needed.
const instance = notificationBannerHelper();

export const useNotificationState = () => {
  const { type, props } = useSyncExternalStore(
    instance.subscribe,
    instance.getSnapshot,
    () => DEFAULT_STATE
  );
  return { type, props };
};

export default instance;
